import { render, staticRenderFns } from "./TgSearchTool.vue?vue&type=template&id=87c88250"
import script from "./TgSearchTool.vue?vue&type=script&lang=js"
export * from "./TgSearchTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports